import React, { useState } from "react";

import SvgClock from "@uui/Clock";

import { TabContext } from "@mui/lab";

import DayAndTimeTabModule from "./DayAndTimeTabModule";
import DurationTabModule from "./DurationTabModule";
import MeetingSizeTabModule from "./MeetingSizeTabModule";
import ModuleHeader from "../components/ModuleHeader";
import ModuleTabPanel from "../components/ModuleTabPanel";
import ModuleTitle from "../components/ModuleTitle";
import {
  WorkspaceModule,
  WorkspaceModuleBody,
  WorkspaceModuleTab,
  WorkspaceModuleTabs,
} from "../components/styles";

const MeetingScheduler = () => {
  const [selected, setSelected] = useState("dayAndTime");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelected(newValue);
  };

  return (
    <WorkspaceModule>
      <ModuleHeader>
        <ModuleTitle icon={SvgClock}>Meeting Scheduler</ModuleTitle>
      </ModuleHeader>
      <WorkspaceModuleTabs value={selected} onChange={handleChange}>
        <WorkspaceModuleTab label="Day & Time" value="dayAndTime" />
        <WorkspaceModuleTab label="Duration" value="duration" />
        <WorkspaceModuleTab label="Size" value="size" />
      </WorkspaceModuleTabs>
      <TabContext value={selected}>
        <WorkspaceModuleBody>
          <ModuleTabPanel value="dayAndTime" sx={{ height: "240px" }}>
            <DayAndTimeTabModule />
          </ModuleTabPanel>
          <ModuleTabPanel value="duration" sx={{ height: "240px" }}>
            <DurationTabModule />
          </ModuleTabPanel>
          <ModuleTabPanel value="size" sx={{ height: "240px" }}>
            <MeetingSizeTabModule />
          </ModuleTabPanel>
        </WorkspaceModuleBody>
      </TabContext>
    </WorkspaceModule>
  );
};
export default MeetingScheduler;
